<script lang="ts" setup>

import type { Price } from "@/models/Price";
import TooltipComponent from "@/components/utils/TooltipComponent.vue";
import IconInfo from "@/components/icons/IconInfo.vue";

defineProps<{
  prices: Price[];
}>();
</script>

<template>
  <TooltipComponent v-if="prices.length > 1" class="text-left">
    <template #content>
      <b> {{ $t("tooltip.price_tier") }}</b><br>
      <span v-for="price in prices" :key="price.from">
        {{ $t("tooltip.from") }} {{price.from }}: {{ $n(price.price, 'currency') }}<br>
      </span>
    </template>
    <IconInfo></IconInfo>
  </TooltipComponent>
</template>
